import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15 15v70h70V15zm10 10h50v50H25z" })
});
export default SvgSquare;
